import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import React from "react";

import Settings from '../../settings.json';

const DayadaPasswordDialog = observer(props => {

    const {modalStore, generalStore} = useStores();

    function closeModal() {
        modalStore.isDayadaPasswordDialogOpen = false;
    }

    async function copyCredentialsToClip() {
        const link = Settings.dayadaAppLink; // TODO prod
        const textToCopy = `${generalStore.translate('userName')}: ${modalStore.modalData.dayadaLoginDetails?.username}
${generalStore.translate('password')}: ${modalStore.modalData.dayadaLoginDetails?.password}

Get mobile app here: ${link}`;

        await navigator.clipboard.writeText(textToCopy);
        modalStore.showSuccessMessage(generalStore.translate('linkCopied'))
    }

    return (
        <Dialog
            open={modalStore.isDayadaPasswordDialogOpen}
            onClose={closeModal}
            className='dialog dayada-login-details-dialog'
        >
            <DialogTitle className="dialog-description">
                {generalStore.translate('patientLoginDetails')}
            </DialogTitle>
            <DialogContent>

                <div className="dialog-description">
                    <b>{generalStore.translate('userName')}</b>: {modalStore.modalData.dayadaLoginDetails?.username}
                </div>
                <div className="dialog-description">
                    <br/>
                    <b>{generalStore.translate('password')}</b>: {modalStore.modalData.dayadaLoginDetails?.password}
                </div>
                <div className="dialog-description">
                    <br/>
                    {generalStore.translate('pleaseCopyThePasswordSinceYouCannotShowItAgain')}
                </div>
                <DialogActions>
                    <Button onClick={copyCredentialsToClip} className='cancel-primary-button'>
                        {generalStore.translate('copyShareMessage')}
                    </Button>
                    <Button onClick={closeModal} className='cancel-primary-button'>
                        {generalStore.translate('gotIt')}
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
});

export default DayadaPasswordDialog;
